// Pagina TERMINI — predisposta per il testo definitivo (fornito successivamente).
export default function Terms() {
  return (
    <div className="min-h-screen bg-[#fdf6ec] px-6 py-12 flex justify-center">
      <div
        data-testid="terms-page"
        className="w-full max-w-2xl bg-white border border-[#f0e4d4] rounded-3xl p-8"
      >
        <h1 className="text-2xl font-extrabold text-[#2b2622] mb-4">
          Termini e Condizioni di utilizzo
        </h1>
        <section data-testid="terms-content" className="text-sm text-[#4a433c] leading-relaxed">
          <p className="text-[#9a8f83]">
            Il testo definitivo dei Termini e Condizioni di utilizzo sarà fornito dal
            committente e inserito in questa sezione.
          </p>
        </section>
      </div>
    </div>
  );
}
